const initIntroSlider = () => {
  const root = document.querySelector('[data-intro-container]');
  if (!root) {
    return;
  }

  const container = root.querySelector('[data-intro-swiper]');
  const pagination = root.querySelector('[data-intro-pagination]');
  if (!container) {
    return;
  }

  // eslint-disable-next-line no-new
  new window.Swiper(container, {
    speed: 700,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: pagination ? {
      el: pagination,
      clickable: true,
    } : undefined,
  });
};

export {initIntroSlider};
